import {
  Directive,
  EventEmitter,
  HostListener,
  input,
  InputSignal,
  Output,
} from '@angular/core';
import { AlertService } from '../services/alert.service';
@Directive({
  selector: '[dropzone]',
})
export class DropzoneDirective {
  readonly accept: InputSignal<string[]> = input<string[]>([]);
  readonly multiple: InputSignal<boolean> = input<boolean>();
  readonly sizeLimit: InputSignal<number> = input<number>(26214400); // in bytes (25MB)
  readonly filesLimit: InputSignal<number> = input<number>(10);

  @Output() selectedFiles = new EventEmitter<FileList>();

  constructor(private alertService: AlertService) {}

  @HostListener('dragenter', ['$event'])
  dragenter(event: DragEvent): void {
    event.stopPropagation();
    event.preventDefault();
  }

  @HostListener('dragover', ['$event'])
  dragover(event: DragEvent): void {
    event.stopPropagation();
    event.preventDefault();
  }

  @HostListener('drop', ['$event'])
  drop(event: DragEvent): void {
    event.stopPropagation();
    event.preventDefault();
    const dataTransfer = event.dataTransfer;
    this.handleSelectedFiles(dataTransfer.files);
  }

  @HostListener('click', ['$event'])
  click = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = this.accept().join(',');
    if (this.multiple) input.multiple = true;
    input.click();

    input.addEventListener('change', (event: Event) => {
      event.stopPropagation();
      event.preventDefault();

      const fileList: FileList = (event.target as HTMLInputElement).files;
      this.handleSelectedFiles(fileList);

      input.removeEventListener('change', (ev1) => {});
    });
  };

  private handleSelectedFiles(fileList: FileList): void {
    if (fileList.length > this.filesLimit()) {
      this.alertService.showErrorMessage('O Limite de arquivos foi excedido!');
      return;
    }

    const files: File[] = Array.from(fileList);

    const filesExtensions = files.map((file) => {
      const dot = file.name.lastIndexOf('.');
      return file.name.substring(dot, file.name.length);
    });

    const filesExtensionsNotValid = filesExtensions.filter(
      (fileExtension) => !this.isFileExtensionValid(fileExtension)
    );

    const isFilesSizesValid = !files.some(
      (file) => file.size > this.sizeLimit()
    );

    if (!filesExtensionsNotValid.length && isFilesSizesValid) {
      this.selectedFiles.emit(fileList);
    } else if (filesExtensionsNotValid.length) {
      this.alertService.showErrorMessage(
        'Um dos arquivos não contém uma extensão valida!'
      );
    } else if (!isFilesSizesValid) {
      this.alertService.showErrorMessage(
        'O tamanho limite do arquivo foi excedido!'
      );
    }
  }

  private isFileExtensionValid(fileExtension: string): boolean {
    return this.accept.length
      ? this.accept().some(
          (acceptedExtension: string) =>
            acceptedExtension.toUpperCase() === fileExtension.toUpperCase()
        )
      : true;
  }
}
